import { useService } from 'react-reservice';

import { ISymbolDetail } from '@aqx-core/common/api/market';

import { pickProperties } from '../../utils';
import { tradeAnalysisService } from './service';

export const useSymbolDetailWithPrices = () =>
  useService(tradeAnalysisService, (context) =>
    pickProperties(context.symbolDetail || {}, ['ask', 'bid', 'high', 'low', 'lastPrice'])
  );

export const useCheckIsSelectedSymbol = (id: string) =>
  useService(tradeAnalysisService, (context) => context.symbolDetailId === id);

export const useSymbolDetailId = () => useService(tradeAnalysisService, (context) => context.symbolDetailId);

/** Retrieves details for a given symbol. Prioritizes option details if available, otherwise fetches details for other symbol types. */
export const useSymbolDetailWithKeys = <K extends keyof ISymbolDetail>(keys: K[]) => {
  return useService(tradeAnalysisService, (context) => {
    return pickProperties(context.symbolDetail || {}, keys);
  });
};

export const useSymbolDetail = () => useService(tradeAnalysisService, (context) => context.symbolDetail);

export const useSymbolTradingTab = () => {
  return useService(tradeAnalysisService, (context) => context.tradingTab);
};

export const useSymbolDetailLoading = () => {
  return useService(tradeAnalysisService, (context) => context.symbolDetailLoading);
};

export const useEditingSymbolDetail = () => {
  return useService(tradeAnalysisService, (context) => context.editingSymbolDetail);
};

export const useIsLoadingEditingSymbolDetail = () => {
  return useService(tradeAnalysisService, (context) => context.editingSymbolDetailLoading);
};

export const useTradeFormContextSymbolDetailWithKeys = <K extends keyof ISymbolDetail>(
  isEditing: boolean,
  keys: K[]
) => {
  return useService(tradeAnalysisService, (context) => {
    const symbolDetail = isEditing ? context.editingSymbolDetail : context.symbolDetail;
    return pickProperties(symbolDetail || {}, keys);
  });
};
